import { createContext, type PropsWithChildren, useContext } from 'react';

export type AcquisitionContextType = {
  hasActivePartner: boolean;
  hasFacebookUTMSource: boolean;
  hasGoogleUTMTerm: boolean;
  isFinanceRestricted: boolean;
};

export const defaultAcquisitionContext: AcquisitionContextType = {
  hasActivePartner: false,
  hasFacebookUTMSource: false,
  hasGoogleUTMTerm: false,
  isFinanceRestricted: false
};

const AcquisitionContext = createContext<AcquisitionContextType>(
  defaultAcquisitionContext
);

export type OwnProps = PropsWithChildren<AcquisitionContextType>;

export function AcquisitionContextProvider({ children, ...value }: OwnProps) {
  return (
    <AcquisitionContext.Provider value={value}>
      {children}
    </AcquisitionContext.Provider>
  );
}

AcquisitionContextProvider.displayName = 'AcquisitionContextProvider';

export default AcquisitionContext;

export function useAcquisitionContext() {
  return useContext(AcquisitionContext);
}
